<template>
  <v-app-bar
      app
      elevation="0"
      color="white"
      absolute
    >
      <div class="d-flex align-center">
        <v-img
          alt="firma.de Logo"
          contain
          :src="`${ASSETS_PREFIX}/beraters/images/logo2x.svg`"
          transition="scale-transition"
        />
      </div>
    </v-app-bar>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      ASSETS_PREFIX: state => state.env.ASSETS_PREFIX,
    }),
  },
}
</script>